import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';

const useStyles = createUseStyles(
  {
    '@keyframes fadeIn': {
      from: { opacity: 0, transform: 'translateY(10px)' },
      to: { opacity: 1, transform: 'translateY(0)' },
    },
    '@keyframes logoGlow': {
      '0%, 100%': {
        filter: 'drop-shadow(0 0 8px rgba(244, 64, 151, 0.4))',
        transform: 'scale(1)',
      },
      '50%': {
        filter: 'drop-shadow(0 0 20px rgba(252, 103, 250, 0.6))',
        transform: 'scale(1.02)',
      },
    },
    '@keyframes dotPulse': {
      '0%, 80%, 100%': {
        opacity: 0.3,
        transform: 'scale(0.8)',
      },
      '40%': {
        opacity: 1,
        transform: 'scale(1)',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      gap: 24,
      backgroundColor: BackgroundColors.base,
    },
    logo: {
      width: 64,
      height: 64,
      animation: '$fadeIn 0.5s ease-out, $logoGlow 2.5s ease-in-out infinite',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 16,
      animation: '$fadeIn 0.5s ease-out 0.15s both',
    },
    title: {
      fontSize: 20,
      fontWeight: 600,
      background: 'linear-gradient(135deg, #F44097 0%, #FC67FA 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    dots: {
      display: 'flex',
      gap: 6,
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: TextColors.tint2,
      animation: '$dotPulse 1.4s ease-in-out infinite',
      '&:nth-child(1)': { animationDelay: '0s' },
      '&:nth-child(2)': { animationDelay: '0.2s' },
      '&:nth-child(3)': { animationDelay: '0.4s' },
    },
  },
  { name: 'app-loader' }
);

export default useStyles;
